import { SAHeader, SAText } from '@saux/design-system-react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import error from '../../icons/Error.png';
import { simpleGTMDataLayer } from '../../utils/utilities';


const SATextCenter = styled(SAText)`
    text-align:center;
    margin-bottom:10px;
`;

export default function NoAccessPage() {
    const user = useSelector((state: any) => state.user)

    useEffect(() => {
        simpleGTMDataLayer({
            csrId: user.userName,
            event: `Unauthorized-Access-Page`,
            event_action: 'Accessing Application',
            event_category: window.location.pathname,
            event_label: `Unauthorised to the Application`,
            event_value: `${user.fullName} doesn't have required privileges to Access Application`
        });
        simpleGTMDataLayer({
            csrId: user.userName,
            event: `Unauthorized-Access-Page-SnowPlow`,
            event_action: 'Accessing Application',
            event_category: window.location.pathname + '/Snowplow',
            event_label: `Unauthorised to the Application`,
            event_value: `${user.fullName} doesn't have required privileges to Access Application`
        });
    }, [])
    return (
        <>
            <SAHeader />
            <div style={{ textAlign: "center", marginTop: 50 }}>
                <img src={error} alt="" height="150" width="150"></img>
                <div style={{ width: 400, margin: "auto" }}>
                    <SATextCenter text="Access Not Authorized" type="heading-1" />
                    <br />
                    <br />
                    <SAText text="This account is not authorized to access the State Auto Quick Text application." type="standard" />
                    <br />
                    <br />
                    <SAText text="If you believe you are seeing this error by mistake, please reach out to a Claims team manager to request access." type="standard" />
                </div>
            </div>
        </>
    )
}
